/* eslint-disable react/react-in-jsx-scope */
import i18n from "@/i18n";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { TriangleAlert } from "lucide-react";

const StatCardColoredSharing: FC<{
  showWarningFinancement: boolean;
  totalFinancement: number;
  totalSuivi: number;
  indicatorsInitial: any[];
  indicators: any[];
  contributionObtenu: number;
  appelAContribution: number;
  context: "programme" | "dashboard" | null;
  isMobile?: boolean;
}> = ({
  showWarningFinancement,
  totalFinancement,
  totalSuivi,
  indicatorsInitial,
  indicators,
  contributionObtenu,
  appelAContribution,
  context = null,
  isMobile = false,
}) => {
  const { t } = useTranslation("dashboard", {
    keyPrefix: "program",
  });
  const [totalFin, setTotalFin] = useState(
    contributionObtenu + appelAContribution
  );
  useEffect(() => {
    setTotalFin(contributionObtenu + appelAContribution);
  }, [contributionObtenu, appelAContribution]);

  const colorClasses = [
    "text-verdeoorange bg-verdeoorange",
    "text-verdeoblue bg-verdeoblue",
    "text-verdeogray bg-verdeogray",
    "text-verdeored bg-verdeored",
    "text-verdeogreen bg-verdeogreen",
  ];

  // const er = indicators?.filter(
  //   (ind: any) => ind.type === 1 && ind.indicator.code === "euro_recus"
  // );

  return (
    <>
      <Carousel
        opts={{
          align: "start",
        }}
        className={isMobile ? "text-center w-full" : " w-full text-left"}
        orientation={isMobile ? "vertical" : "horizontal"}
      >
        <CarouselContent
          className={`w-full ${isMobile ? "-mt-1 h-[500px]" : ""}`}
        >
          {/* <CarouselItem key={"ct"} className="basis-[30%] overflow-hidden">
            <CardColored
              className={colorClasses[0 % colorClasses.length]}
              title={t("Coût total prévu")}
              // value={contributionObtenu ? contributionObtenu.toFixed(2) : "0"}
              // desc={`Obj ${indicators[0].totalYear || 1} ans : ${totalFin.toFixed(1)}`}
              value={`${
                isNaN(totalFin) || totalFin === null ? 0 : totalFin.toFixed(1)
              }`}
              desc={
                contributionObtenu && !isNaN(contributionObtenu)
                  ? contributionObtenu.toFixed(1)
                  : 0
              }
              showWarningFinancement={false}
              totalFinancement={totalFinancement}
              totalSuivi={totalSuivi}
              unity="€"
            />
          </CarouselItem> */}
          {indicatorsInitial
            ?.filter((ind: any) => {
              if (ind.code === "euro_recus" || ind.id === 2) return false;

              const total1 =
                indicators.find(
                  (i: any) => i.indicator.id === ind.id && i.type === 1
                )?.total || 0;

              const total2 =
                indicators.find(
                  (i: any) => i.indicator.id === ind.id && i.type === 2
                )?.total || 0;

              // garder uniquement si au moins un des deux est > 0
              return !(total1 === 0 && total2 === 0);
            })
            .map((ind: any, index: number) => {
              const colorClass =
                colorClasses[(index + 1) % colorClasses.length];

              const unity = indicators.find(
                (i: any) => i.indicator.id === ind.id && i.type === 1
              )?.indicator.unity;
              return (
                <CarouselItem
                  key={ind?.id}
                  className="basis-[30%] overflow-hidden"
                >
                  <CardColored
                    className={colorClass}
                    title={
                      ind?.indicatorLangs?.find(
                        (ptl: any) => ptl.lang.code === i18n.language
                      )?.name || ind.name
                    }
                    value={
                      indicators.find(
                        (i: any) => i.indicator.id === ind.id && i.type === 1
                      )?.total || 0
                    }
                    desc={
                      indicators.find(
                        (i: any) => i.indicator.id === ind.id && i.type === 2
                      )?.total || 0
                    }
                    showWarningFinancement={
                      ind.code === "euro_recus" && showWarningFinancement
                    }
                    totalFinancement={totalFinancement}
                    totalSuivi={totalSuivi}
                    unity={unity != "Nombre" && unity != "price" ? unity : ""}
                  />
                </CarouselItem>
              );
            })}
        </CarouselContent>
        {indicatorsInitial.filter(
          (ind: any) => ind.code !== "euro_recus" && ind.id !== 2
        ).length > 2 && (
          <CarouselPrevious
            className={`m-0 p-0 index-9 absolute ${
              isMobile ? "right-[-20px]" : "left-[-15px]"
            } shadow-md hover:shadow-xl`}
          />
        )}

        {indicatorsInitial.filter(
          (ind: any) => ind.code !== "euro_recus" && ind.id !== 2
        ).length > 2 && (
          <CarouselNext className="m-0 p-0 index-9 absolute right-[-20px] shadow-md  hover:shadow-xl" />
        )}
      </Carousel>
    </>
  );
};

const CardColored: FC<{
  showWarningFinancement?: boolean;
  totalFinancement?: number;
  totalSuivi?: number;
  title: string;
  value: number;
  desc: number;
  className: string;
  unity?: string;
}> = ({
  showWarningFinancement = false,
  totalFinancement = 0,
  totalSuivi = 0,
  title,
  value,
  desc,
  className,
  unity,
}) => {
  const { t } = useTranslation("dashboard", {
    keyPrefix: "program",
  });
  return (
    <div
      className={`rounded-[11px] px-[10px] py-[13px] overflow-hidden ${
        className.split(" ")[0]
      } relative`}
      title={title}
    >
      <div className="relative z-10">
        <h3 className="mb-2 text-[14px] font-semibold line-clamp-2">
          {title} {t("prévu")}
        </h3>
        <p className="mb-1 text-[20px] font-semibold">
          {Math.round(value).toLocaleString("fr-FR")} {unity}
        </p>
        <div className="flex gap-2 justify-between">
          <p className="mb-0 text-[12px]">
            {t("Déjà réalisé")} : {Math.round(desc).toLocaleString("fr-FR")}{" "}
            {unity}
          </p>
          {showWarningFinancement && (
            <Popover>
              <PopoverTrigger asChild>
                <TriangleAlert
                  className="cursor-pointer"
                  size={15}
                  color="#FF0000"
                />
              </PopoverTrigger>
              <PopoverContent className="text-xs">
                {t(
                  "Une différence a été constatée entre les financements saisis et les indicateurs de suivi des versements. Merci de vérifier et de corriger."
                )}{" "}
                <br />
                {t(
                  "Pour rappel vous avez déclaré en financements souhaités + ceux déjà obtenus ="
                )}{" "}
                <b>{Math.round(totalFinancement).toLocaleString("fr-FR")} €</b>{" "}
                <br />
                {t("Ceux enregistrés sur vos tableaux de suivi =")}{" "}
                <b>{Math.round(totalSuivi).toLocaleString("fr-FR")} €</b>
              </PopoverContent>
            </Popover>
          )}
        </div>
      </div>
      <div
        className={`${
          className.split(" ")[1]
        } opacity-10 absolute top-0 left-0 w-full h-full`}
      ></div>
    </div>
  );
};
export default StatCardColoredSharing;
